






import { Component, Prop, Vue } from 'vue-property-decorator';

@Component
export default class Icon extends Vue {
  @Prop() src!: string;

  @Prop() width!: number;

  @Prop() height!: number;
}
